import { render } from "./component.vue?vue&type=template&id=5f0f0b7a"
import script from "./component.vue?vue&type=script&setup=true&lang=js"
export * from "./component.vue?vue&type=script&setup=true&lang=js"

import "./component.vue?vue&type=style&index=0&id=5f0f0b7a&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/plugins/notifications/component.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5f0f0b7a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5f0f0b7a', __exports__)) {
    api.reload('5f0f0b7a', __exports__)
  }
  
  module.hot.accept("./component.vue?vue&type=template&id=5f0f0b7a", () => {
    api.rerender('5f0f0b7a', render)
  })

}


export default __exports__